import React, { useState } from "react";

const ConvertModal = ({ isOpen, onClose, ModalData, handleIconClick, convertTypeList }) => {
  const [TransType, settransType] = useState("");

  console.log("convertTypeList", convertTypeList)
  if (!isOpen) {
    return null;
  }

  const handleOk = (data) => {
    ;
    if (data) {
      handleIconClick(data.ItemId, data.ReportAttachTo, TransType);
    }
  };

  return (
    <div className="BillBar-modal">
      <div className="BillBar-modal-content">
        <div className="BillBar-modal-header">
          <h2>Confirm!</h2>
          <button onClick={onClose} className="BillBar-modal-close">
            ✖
          </button>
        </div>
        <p className="mt-2">Select Transaction Type!!</p>
        <div className="BillBar-modal-dropdown">
          <select
            className="BillBar-modal-select enhanced-dropdown"
            onChange={(e) => settransType(e.target.value)}
          >
            <option value="">---Select---</option>

           
            {convertTypeList.map((convertType, index)=>(
              <option key={index} value={convertType.id}>{convertType.name}</option>
            ))}

          </select>
        </div>
        <div className="mt-4" style={{ textAlign: "center" }}>
          {/* <button className="BillBar-modal-ok-btn">OK</button> */}
          <button
            onClick={() => handleOk(ModalData)}
            className="BillBar-modal-close-btn"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConvertModal;
